<div *ngIf="data.type === 'User'" class="scrollable-section" #scrollableSection>
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button" (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>
  <br><br>
  <dx-data-grid id="gridContainer" [dataSource]="dataSource" (onToolbarPreparing)="onToolbarPreparing($event)"
    (onEditorPreparing)="onEditorPreparing($event)" (onSelectionChanged)="onSelectionChanged($event)"
    (onContentReady)="onDataGridContentReady($event)" keyExpr="user1">

    <!-- Definición de las columnas -->
    <dxo-selection mode="multiple" showCheckBoxesMode="always" caption="Seleccionar"></dxo-selection>
    <dxi-column caption="Empresa" alignment="center">
      <dxi-column dataField="company.companyCode" caption="Código" alignment="center"></dxi-column>
      <dxi-column dataField="company.name" caption="Empresa" alignment="center"> </dxi-column>
    </dxi-column>
    <dxi-column caption="Centro" alignment="center">
      <dxi-column dataField="imputationCode" caption="Código" alignment="center"> </dxi-column>
      <dxi-column dataField="workplaceName" caption="Centro" alignment="center"> </dxi-column>
    </dxi-column>
    <dxi-column caption="Imputación" alignment="center">
      <dxi-column dataField="imputationCode" caption="Código" alignment="center"> </dxi-column>
      <dxi-column dataField="imputationName" caption="Imputacion" alignment="center"> </dxi-column>
    </dxi-column>
    <dxi-column caption="Trabajador" alignment="center">
      <dxi-column dataField="employeeCode" caption="Código" alignment="center"> </dxi-column>
      <dxi-column dataField="fullName" caption="Trabajador" alignment="center"> </dxi-column>
    </dxi-column>
    

  </dx-data-grid>
  <!-- Botonera -->
  <div class="row col-12 float-right ">
    <label class="col-12"></label>
    <div class="col-12">
      <div class="form-group form-button">
        <button class="btn btn-fill btn-primary float-right" type="submit" (click)="onSubmitUser()">Publicar</button>
        <a class="btn btn-fill btn-outline-white button-white float-right" (click)="closePopUp(false)">Volver</a>
      </div>
    </div>
  </div>
</div>